import { StepType } from '@pushly/models/lib/enums/journeys'
import { LAYOUT_CONSTANTS } from './elk-config'
import { CONVERGENCE_PLACEHOLDER_SIZE } from '../constants'
import { JourneyNode } from '../types/journey-nodes'

export function isConvergencePlaceholderNode(node?: JourneyNode): boolean {
    return !!node
        && node.data.step.type === StepType.PLACEHOLDER
        && node.data.uiMeta?.placeholderRole === 'convergence'
}

export function getNodeLayoutDimensions(node?: JourneyNode): { width: number; height: number } {
    if (isConvergencePlaceholderNode(node)) {
        return {
            width: CONVERGENCE_PLACEHOLDER_SIZE,
            height: CONVERGENCE_PLACEHOLDER_SIZE,
        }
    }

    return {
        width: node?.measured?.width ?? LAYOUT_CONSTANTS.MIN_NODE_WIDTH,
        height: node?.measured?.height ?? LAYOUT_CONSTANTS.MIN_NODE_HEIGHT,
    }
}
